import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = () => {
	const jsThemesDrop = $('.js-themes-drop-down');
	const jsThemesList = $('.js-themes-list');

	function toggleDropDown(event) {
		event.preventDefault();
		jsThemesDrop.toggleClass('is-active');
		if (jsThemesDrop.hasClass('is-active')) {
			jsThemesDrop.attr('aria-expanded', true);
		} else {
			jsThemesDrop.attr('aria-expanded', false);
		}
		jsThemesList.slideToggle();
	}

	if (MQ('lgUp')) {
		jsThemesDrop.removeAttr('aria-haspopup');
		jsThemesDrop.removeAttr('aria-expanded');
	} else if (MQ('mdDown')) {
		jsThemesDrop.attr('aria-expanded', false);
		jsThemesDrop.attr('aria-haspopup', true);
	}

	jsThemesDrop.on('click', toggleDropDown);

	$(window).on('resize', () => {
		if (MQ('mdUp') && jsThemesList.attr('style')) {
			jsThemesList.removeAttr('style');
		}
	});
};
